/**
 * Returns the icon for an object, such as a bookmark or briefing book.
 * The object must have a url property and may also have a type.
 */
import _ from 'lodash'

import metadata from './metadata'

const domainTypeIcons = _.reduce(metadata, (acc,m) => {
	if (m.domainType && m.sectionIcon) {
		acc[`${m.domainType}s`] = m.sectionIcon
	}
	return acc
}, {})
// For these we prefer the singular icon instead of the section icon
domainTypeIcons['scorecards'] = 'scorecard'
domainTypeIcons['initiatives'] = 'initiative'
domainTypeIcons['files'] = 'document-blank'
domainTypeIcons['reports'] = 'reports'

function iconForObject(object, defaultIcon) {
	if (object.type == 'folder') {
		return 'folder'
	}

	if (object.subtype) {
		if (object.subtype === 'view') {
			return 'dataset-view'
		}
		if (object.subtype === 'briefing') {
			return domainTypeIcons['briefings']
		}
		if (object.subtype === 'file') {
			return domainTypeIcons['files']
		}
		if (object.subtype === 'report' ||
				object.type === 'report') {
			return domainTypeIcons['reports']
		}
		if (object.subtype == 'root') { // #59522
			return domainTypeIcons['scorecards']
		}
		return object.subtype
	}

	const section = _.split(object.url, '/')[0]
	return domainTypeIcons[section] || defaultIcon
}

export default iconForObject

iconForObject.__filename__ = 'components/icon-for-object.js'
